module.exports = __webpack_public_path__ + "assets/a-4-lunyi.0fc84730.svg";